import React from 'react';
import { Link } from 'react-router-dom';
import CloudinaryAdvancedImage from '@common/utils/CloudinaryAdvancedImage';

function DiscoverProduct({title, imgUrl, link}) { 
  return (
    <div className='bs-discover-product'>
        <div className='bs-discover-product__title-wrap'>
            <h3 className='bs-discover-product__title'>{title}</h3>
        </div>
        <div className='bs-discover-product__info-wrap'>
            <div className='bs-discover-product__media-wrap'>
                <Link to={link} className='bs-discover-product__media-link'>explore now</Link>
                <CloudinaryAdvancedImage imagePublicId={imgUrl} className='bs-discover-product__image' type="by3"/>
            </div>
            <Link to={link} className='bs-btn bs-btn__btn-solid bs-discover-product__action'>explore now</Link>
        </div>
    </div>
  )
}

export default DiscoverProduct